/**
 * A Hook Specifically for CDF Chart
 */

import ChartBuilder, { generateCircleLegendLabels } from './chart_builder'

export default {
  setup() {
    const defaultOptions = {
      responsive: true,
      maintainAspectRatio: false,
      elements: {
        line: {
          borderWidth: 3,
          tension: 0.3 // Adds a slight curve to the line
        },
        point: {
          pointHitRadius: 3,
          radius: 2
        }
      },
      scales: {
        x: {
          title: {
            display: true,
            text: '% Acres Treated',
            color: 'rgba(0, 0, 0, 0.38)',
            font: {
              weight: 500
            }
          },
          grid: {
            display: false
          },
          ticks: {
            callback: (value) => {
              // format to percentage with no decimal places
              return Math.round(value * 100) + '%'
            }
          }
        },
        y: {
          title: {
            display: true,
            text: '% Max RO',
            color: 'rgba(0, 0, 0, 0.38)',
            font: {
              weight: 500
            }
          },
          beginAtZero: true,
          ticks: {
            maxTicksLimit: 6,
            callback: (value) => {
              // format to percentage with no decimal places
              return Math.round(value * 100) + '%'
            }
          }
        }
      },
      plugins: {
        legend: {
          display: true,
          position: 'bottom',
          align: 'start',
          labels: {
            font: {
              size: 12
            },
            usePointStyle: true,
            pointStyleWidth: 18,
            padding: 16,
            generateLabels: (chart) => generateCircleLegendLabels(chart)
          }
        },
        // TODO Dry Up Tooltips Across Charts
        tooltip: {
          mode: 'nearest',
          intersect: true,
          backgroundColor: '#fff',
          bodyColor: '#000000DE',
          bodyFont: {
            size: 14
          },
          bodySpacing: 8,
          borderColor: '#cecece',
          borderWidth: 1,
          boxPadding: 8,
          filter: function (_tooltipItem, data) {
            // Only show the first tooltip label
            return data === 0
          },
          padding: 16,
          position: 'nearest',
          titleColor: '#00000099',
          titleFont: { size: 12, weight: 'normal' },
          titleMarginBottom: 14,
          displayColors: false,
          usePointStyle: true,
          callbacks: {
            title: function (context) {
              return context === undefined || context.length == 0
                ? ''
                : context[0].dataset.label
            },
            label: function (context) {
              return [
                `Treating ${context.raw.acres.toLocaleString()} acres (${Math.round(context.label * 100)}%)`,
                `provides ${Math.round(context.formattedValue * 100)}% of the RO`
              ]
            }
          }
        }
      }
    }
    const data = JSON.parse(this.el.dataset.chartData)
    const options = JSON.parse(this.el.dataset.chartOptions || '{}')
    this.chart = new ChartBuilder(
      this.el,
      'scatter',
      data,
      defaultOptions,
      options
    ).chart
  },
  destroy() {
    this.chart?.destroy()
    this.chart = null
  },
  mounted() {
    this.setup()
    this.handleEvent('download_chart_png', ({ chart_id, filename }) => {
      if (chart_id !== this.el.id) return
      if (!this.chart) return

      const source = this.chart.canvas
      const exportCanvas = document.createElement('canvas')
      exportCanvas.width = source.width
      exportCanvas.height = source.height
      const context = exportCanvas.getContext('2d')
      if (!context) return

      context.fillStyle = '#FFFFFF'
      context.fillRect(0, 0, exportCanvas.width, exportCanvas.height)
      context.drawImage(source, 0, 0)

      exportCanvas.toBlob((blob) => {
        if (!blob) return

        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)

        // Hint to the browser to release the GPU-backed canvas backing store
        exportCanvas.width = 0
        exportCanvas.height = 0
      }, 'image/png')
    })
  },
  updated() {
    ChartBuilder.refresh_data(this)
  },
  destroyed() {
    this.destroy()
  }
}
